'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { type BeforeInstallPromptEvent } from '../../../../globals';
import { useShouldShowInstallPrompt } from './use-should-show-install-prompt';
export const useWebInstallPrompt = () => {
  const $ = _c(12);
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [userShouldBePromptedToInstall, hideInstallPrompt] = useShouldShowInstallPrompt("webInstallPromptedAt");
  let t0;
  let t1;
  if ($[0] !== userShouldBePromptedToInstall) {
    t0 = () => {
      const handleBeforeInstallPrompt = event => {
        event.preventDefault();
        if (userShouldBePromptedToInstall) {
          setInstallPromptEvent(event);
        }
      };
      window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      return () => window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
    t1 = [userShouldBePromptedToInstall];
    $[0] = userShouldBePromptedToInstall;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== hideInstallPrompt) {
    t2 = () => {
      hideInstallPrompt();
      setInstallPromptEvent(null);
    };
    $[3] = hideInstallPrompt;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleInstallDeclined = t2;
  let t3;
  if ($[5] !== hideInstallPrompt || $[6] !== installPromptEvent) {
    t3 = async () => {
      if (!installPromptEvent) {
        return;
      }
      await installPromptEvent.prompt();
      const userChoice = await installPromptEvent.userChoice;
      if (userChoice?.outcome !== "accepted") {
        hideInstallPrompt();
      }
      setInstallPromptEvent(null);
    };
    $[5] = hideInstallPrompt;
    $[6] = installPromptEvent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleInstallAccepted = t3;
  let t4;
  if ($[8] !== handleInstallAccepted || $[9] !== handleInstallDeclined || $[10] !== installPromptEvent) {
    t4 = [installPromptEvent, handleInstallDeclined, handleInstallAccepted];
    $[8] = handleInstallAccepted;
    $[9] = handleInstallDeclined;
    $[10] = installPromptEvent;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};